import { css } from '@styled-system/css';
import { type FC, useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { ProductFeed } from '@/shared/components/product/ProductFeed';
import { Message } from '@/shared/components/ui/Message';

import { SELL_HISTORY_TAB_STATUS_MAPPING, SELL_HISTORY_TABS, VENDOR_SELL_HISTORY_TABS, type SellHistoryTabValue } from '../types';
import { SellHistoryTabs } from './SellHistoryTabs';

export interface AnalysisPageSellsHistProps {
  /** 'vendor' : seulement Ventes + En vente (le stock du profil). */
  variant?: 'product' | 'vendor';
}

export const AnalysisPageSellsHist: FC<AnalysisPageSellsHistProps> = ({ variant = 'product' }) => {
  const { t } = useTranslation();
  const { id: analysisId } = useParams<{ id: string }>();
  const [activeTab, setActiveTab] = useState<SellHistoryTabValue>('sold');
  const tabs = variant === 'vendor' ? VENDOR_SELL_HISTORY_TABS : SELL_HISTORY_TABS;

  // Marge haute pour décoller le contenu du divider des onglets principaux.
  const containerStyles = css({
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    gap: '5',
    paddingTop: '3',
  });

  const handleTabChange = useCallback((tab: SellHistoryTabValue) => {
    setActiveTab(tab);
  }, []);

  if (!analysisId) {
    return (
      <div className={containerStyles}>
        <Message type="error" bordered>
          {t('analysisDetail.missingId')}
        </Message>
      </div>
    );
  }

  return (
    <div className={containerStyles}>
      {/* Le sélecteur Ventes/Retirés/Invendus ouvre la toolbar du feed :
          tout tient sur une seule ligne. */}
      <ProductFeed
        status={SELL_HISTORY_TAB_STATUS_MAPPING[activeTab]}
        toolbarLeading={<SellHistoryTabs activeTab={activeTab} onTabChange={handleTabChange} tabs={tabs} />}
      />
    </div>
  );
};
